import AppInputFieldV2 from 'components/Common/AppInputFIeldV2'
import CommonButton from 'components/Common/CommonButton';
import ErrorComponent from 'components/shared/ErrorComponent';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import LoadingOverlay from 'components/shared/LoadingOverlay';
import CustomEditor from 'components/TipTapEditor/CustomeEditor';
import { FieldArray, Form, Formik } from 'formik'
import { cloneDeep, isEmpty } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useCreateTaskPlanTemplateMutation, useGetSingleTaskPlanTemplatesQuery, useUpdateTaskPlanTemplatesMutation } from 'store/services/V2/TaskPlanTemplate';
import { successMessageToast } from 'helpers/common';
import { useNavigate, useParams } from 'react-router-dom';
import { TASK_PLAN_TEMPLATES } from 'config/paths';
import { genericFormErrorMsg } from 'utils/validation/validationHelpers';
import { TaskTemplateStrategyForm } from 'components/shared/TaskPlanTemplate/StratergyForm';
import addTaskPlanTemplateSchema from './addTaskPlan.schema';
import AppDatePicker from 'components/shared/FormComponents/AppDatePicker';

function TaskPlanTemplateAdd() {
    const navigate = useNavigate()

    const { id } = useParams()
    const [isEdit, setIsEdit] = useState(false)
    const { data: singleTemplate, isLoading: templateLoading } = useGetSingleTaskPlanTemplatesQuery({ id }, { skip: !id })

    const [createTaskPlanTemplate, { isLoading: createTaskLoading }] = useCreateTaskPlanTemplateMutation()
    const [updateTaskPlanTemplates, { isLoading: updateTaskLoading }] = useUpdateTaskPlanTemplatesMutation()

    let taskPlanError = ""

    const emptyTask = {
        task_title: "",
        date: "",
        description: "",
        strategy: [{
            text: "",
            attachments: []
        }]
    }

    const emptyStrategy = {
        text: "",
        attachments: []
    }

    useEffect(() => {
        if (id) setIsEdit(true)
    }, [id])

    const initialValues = useMemo(() => {
        const taskData = singleTemplate || emptyTask;
        return {
            ...taskData,
            strategy: taskData.strategy || []

        }
    }, [singleTemplate])

    const handleSubmit = async (values) => {
        try {
            const payload = await cloneDeep(values)
            const finalPayload = {
                attachments: payload?.attachments || [],
                task_title: payload?.task_title || "",
                date: payload?.date || "",
                description: payload?.description || "",
                strategy: payload?.strategy?.map((item) => ({
                    ...item,
                    template_id: item?.template_id?.toString() || "",
                    stragety_id: item?.stragety_id || "",
                    title: item?.title || ""

                }))
            }
            const resp = isEdit
                ? await updateTaskPlanTemplates({ values: finalPayload, id }).unwrap()
                : await createTaskPlanTemplate(finalPayload).unwrap()

            if (resp.status === "success") {
                successMessageToast(isEdit ? "Template updated successfully" : "Template created successfully");
                navigate(TASK_PLAN_TEMPLATES)
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <section className='client position-relative py-4 col-lg-10'>
            <Container fluid>
                {templateLoading ? <div style={{ height: "200px" }}><LoadingIndicator /></div> :
                    <>
                        <div style={{ borderBottom: "1px solid #315D99" }}>
                            <h3 className='support-staff-heading' style={{ color: "#315D99" }}>
                                CREATE A TASK PLAN TEMPLATE
                            </h3>
                        </div>
                        <Row>
                            {(templateLoading) && <LoadingOverlay />}

                            <Col lg="12" className="my-2">
                                {taskPlanError ? (
                                    <ErrorComponent />
                                ) : (
                                    <Formik
                                        initialValues={initialValues}
                                        onSubmit={handleSubmit}
                                        validationSchema={addTaskPlanTemplateSchema}
                                        enableReinitialize
                                    >
                                        {({ handleSubmit, values, errors, submitCount, setFieldValue, setFieldTouched, touched }) => {
                                            console.log("formik-values", values)

                                            return (
                                                <Form onSubmit={handleSubmit}>
                                                    <FieldArray  >
                                                        {({ push: pushTask, remove: removeTask }) => (
                                                            <div className="">
                                                                <h5 className="section-title mt-3">
                                                                    1. CREATE TASK PLAN TEMPLATE
                                                                </h5>

                                                                <div className="mb-4 ps-3">
                                                                    <Row className='d-flex justify-content-between'>
                                                                        <Col md="9">
                                                                            <label className="discharge-screen-label">
                                                                                Task Title*
                                                                            </label>
                                                                            <AppInputFieldV2
                                                                                name={`task_title`}
                                                                                type="text"
                                                                                className="readonly-box"
                                                                            />
                                                                        </Col>
                                                                        <Col xs="3" xl="2" className='d-flex '>
                                                                            <div className=' reports-v2' style={{ width: "145px" }}>
                                                                                <label className="discharge-screen-label">
                                                                                    Date Created*
                                                                                </label>
                                                                                <AppDatePicker
                                                                                    name={`date`}
                                                                                    className="read-only w-100 py-2"
                                                                                    popperPlacement="bottom-start"
                                                                                    popperClassName="react-datepicker-popper"
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row>

                                                                    {/* DESCRIPTION */}
                                                                    <Col md="9" className="mt-3">
                                                                        <label className="discharge-screen-label">
                                                                            Description*
                                                                        </label>
                                                                        <CustomEditor
                                                                            name={`description`}
                                                                            attachmentName={`attachments`}
                                                                        />
                                                                    </Col>

                                                                    <div className="staff-divider mt-4"></div>

                                                                    {/* STRATEGY SECTION */}
                                                                    <FieldArray name={`strategy`}>
                                                                        {({ push: pushStrategy, remove: removeStrategy }) => (
                                                                            <>
                                                                                {values?.strategy?.map((strategy, strategyIndex) => (
                                                                                    <div key={strategyIndex} className="mb-3 mt-5 position-relative">
                                                                                        <TaskTemplateStrategyForm
                                                                                            strategyIndex={strategyIndex}
                                                                                            setFieldValue={setFieldValue}
                                                                                            values={values}
                                                                                            remove={removeStrategy}
                                                                                            setFieldTouched={setFieldTouched}
                                                                                            assessmentId={null}
                                                                                            clientType="task_plan"
                                                                                            errors={errors}
                                                                                            touched={touched}
                                                                                        />
                                                                                    </div>
                                                                                ))}

                                                                                {
                                                                                    values?.strategy?.length < 2 &&
                                                                                    <div className='d-flex align-items-center gap-3 mt-3'>
                                                                                        <CommonButton
                                                                                            className="staff-button-outlined"
                                                                                            text="Add a Strategy"
                                                                                            onClick={() => pushStrategy(emptyStrategy)}
                                                                                        />
                                                                                    </div>
                                                                                }

                                                                            </>
                                                                        )}
                                                                    </FieldArray>

                                                                    {/* {taskIndex !== values.tasks.length - 1 && (
                                                                        <div className="staff-divider mt-4"></div>
                                                                    )} */}
                                                                </div>

                                                                <div className="staff-divider my-4"></div>

                                                                {/* <div className='d-flex align-items-center gap-3 mt-3'>
                                                                    <CommonButton
                                                                        className="staff-button-outlined"
                                                                        text="Add a Task"
                                                                        onClick={() => pushTask(emptyTask)}
                                                                    />
                                                                </div> */}
                                                            </div>
                                                        )}
                                                    </FieldArray>

                                                    {(!isEmpty(errors) && submitCount > 0) && (
                                                        <div className="mt-4 text-danger">
                                                            {genericFormErrorMsg}
                                                        </div>
                                                    )}

                                                    {/* FOOTER */}
                                                    <div className="d-flex justify-content-between mt-5">
                                                        <CommonButton
                                                            className="staff-button-outlined"
                                                            text="Cancel"
                                                            onClick={() => navigate(TASK_PLAN_TEMPLATES)}
                                                            style={{ border: "1px solid #315D99", color: "#315D99" }}
                                                        />

                                                        <CommonButton
                                                            type="submit"
                                                            className="staff-button-filled"
                                                            style={{ background: "#315D99" }}
                                                            text={
                                                                createTaskLoading || updateTaskLoading
                                                                    ? <LoadingIndicator color="#fff" />
                                                                    : "Save to Templates"
                                                            }
                                                        />
                                                    </div>
                                                </Form>
                                            )
                                        }}
                                    </Formik>
                                )}
                            </Col>
                        </Row>
                    </>
                }
            </Container>
        </section>
    )
}

export default TaskPlanTemplateAdd